/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `leasing_company` - Leasing company
 * * `importer` - Importer
 */
export enum InstallationTypeEnum {
    LEASING_COMPANY = 'LEASING_COMPANY',
    IMPORTER = 'IMPORTER',
}
